// eslint-disable-next-line vue/attribute-hyphenation
<template>
  <MCS :company-id="companyId" :agent-id="userId" @closeConnect="closeConnect" />
</template>

<script>
import MCS from '@telexpress_auth/vue-mcs/dist/components/mcs.umd.min';
import '@telexpress_auth/vue-mcs/dist/components/mcs.css';
import Vue from 'vue';
import store from '@/store';

export default {
  components: {
    MCS,
  },
  data() {
    return {
      leavepopup: true,
      companyId: '',
      userId: ''
    };
  },
  created() {
    this.leavepopup = true;
    this.companyId = store.getters.company;
    this.userId = store.getters.userId;
  },
  methods: {
    closeConnect() {
      this.Message = {
        userId: this.userId,
        companyId: this.companyId
      };
      Vue.prototype.$connect.invoke('AgentSendMessage', { strMessageType: 'AgentLogOut', Message: this.Message }).then(() => {
        Vue.prototype.$connect.stop();
      });
    }
  },
  beforeRouteLeave: MCS.beforerouteleave,
};
</script>
